<div class="mb2 distribution-wizard">
    <div class="pt2 pb2 w-100">
        <div class="flex justify-center center w-80 relative">
            <div class="hr-dash-line ba b--dashed bb absolute w-100"></div>
            <div class="step-container flex flex-column items-center mr4" [ngClass]="{
                'in-active-badge': sendReportStatus < 1, 
                'active-badge': sendReportStatus >= 1, 
                'inprogress': (sendReportStatus+1) == 1
            }">
                <div class="step db badge">1</div>
                <div class="step-title">Generate Report</div>
            </div>
            <div class="step-container flex flex-column items-center mr4" [ngClass]="{
                'in-active-badge': sendReportStatus < 2, 
                'active-badge': sendReportStatus >= 2, 
                'inprogress': (sendReportStatus+1) == 2
            }">
                <div class="step db">2</div>
                <div class="step-title">Send for<br>Approval</div>
            </div>
            <div class="step-container flex flex-column items-center mr4" [ngClass]="{
                'in-active-badge': sendReportStatus < 3, 
                'active-badge': sendReportStatus >= 3, 
                'inprogress': (sendReportStatus+1) == 3
            }">
                <div class="step db">3</div>
                <div class="step-title">Approve/Decline<br>
                    <div [ngClass]="{ 'hide': (sendReportStatus+1) < 3 }">Pending<br>from John Doe</div>
                </div>
            </div>
            <!-- <div class="step-container flex flex-column items-center mr4" [ngClass]="{
                'in-active-badge': sendReportStatus < 4, 
                'active-badge': sendReportStatus >= 4, 
                'inprogress': (sendReportStatus+1) == 4
            }">
                <div class="step db">4</div>
                <div class="step-title">If Approved</div>
            </div> -->
            <div class="step-container flex flex-column items-center mr4" [ngClass]="{
                'in-active-badge': sendReportStatus < 4, 
                'active-badge': sendReportStatus >= 4, 
                'inprogress': (sendReportStatus+1) == 4
            }">
                <div class="step db">4</div>
                <div class="step-title">Send for<br>Distribution</div>
            </div>
            <div class="step-container flex flex-column items-center" [ngClass]="{
                'in-active-badge': sendReportStatus < 5, 
                'active-badge': sendReportStatus >= 5, 
                'inprogress': (sendReportStatus+1) == 5
            }">
                <div class="step db">5</div>
                <div class="step-title">Distribution<br>Completed</div>
            </div>
        </div>
    </div>
</div>